import { render, staticRenderFns } from "./MainSpecialized.vue?vue&type=template&id=15ba05e3"
import script from "./MainSpecialized.vue?vue&type=script&lang=js"
export * from "./MainSpecialized.vue?vue&type=script&lang=js"
import style0 from "./MainSpecialized.vue?vue&type=style&index=0&id=15ba05e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports